import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { WideLayout } from '../../../shared/layout/widelayout';
import { useLayoutStore } from '../../../stores/portalStore';
import { useCollectionStore } from '../store/collectionStore';
import { usePatientsStore } from '../../patients/store/patientsStore';
import { PatientsList } from '../../patients/usecases/legacy/list';
import { useResponsive } from '../../../hooks/useResponsive';

const MainPanels = () => {
  const setSelectedPatient = useCollectionStore(
    (state) => state.setSelectedPatient
  );
  const selectedPatient = useCollectionStore((state) => state.selectedPatient);
  const reset = useCollectionStore((state) => state.reset);
  const patients = usePatientsStore((state) => state.patients);
  const header = ['Nome', 'CPF', 'Empresa', 'CNPJ', 'Endereço'];
  const fields = ['name', 'cpf', 'company', 'cnpj', 'address'];
  const navigate = useNavigate();
  const contentWidth = useLayoutStore((state) => state.contentWidth);
  const { isDesktop } = useResponsive();
  const containerWidth = isDesktop && contentWidth ? contentWidth : '100%';

  useEffect(() => {
    reset();
  }, []);

  const onRowSelected = (_row, rowIndex) => {
    setSelectedPatient(patients[rowIndex]);
  };

  const continueToCategory = () => {
    if (selectedPatient !== null) {
      navigate('/collectEquipments/collectEquipments');
    }
  };

  return (
    <div
      style={{
        maxWidth: containerWidth,
        margin: '15px',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '16px',
      }}
    >
      <PatientsList
        title={'Recolhimento'}
        topSearchRight={true}
        onlyActives={false}
        newClientAction={
          <PrimaryButton onClick={continueToCategory}>Prosseguir</PrimaryButton>
        }
        height={window.innerHeight - 400 + 'px'}
        subtitle={''}
        readOnly={true}
        header={header}
        fields={fields}
        onRowSelected={onRowSelected}
        disableSearchWhileLoading={true}
        resetSearchOnMount={true}
        useOrderFlowTable={true}
        manualSearch={true}
      />
    </div>
  );
};

export const CollectionSelectPatientsPage = () => {
  return <WideLayout outlet={<MainPanels />} />;
};
